import { RolModel } from "../../models/businessModels/RolModel";
import CsmGenericMultiSelectChipField, { ICsmGenericMultiSelectChipFieldProps } from "../../library/components/mui/select/CsmGenericMultiSelectChipField";

export type IVatanRolMultiSelectFieldProps = Omit<ICsmGenericMultiSelectChipFieldProps<RolModel, string>, "list" | "labelGetter" | "valueGetter"> & { tumRoller: RolModel[] };

function VatanRolMultiSelectField(props: IVatanRolMultiSelectFieldProps) {
    const { tumRoller, ...rest } = props;
    const orderedRolList = tumRoller.orderByTurkish(e => e.isim);

    return (
        <CsmGenericMultiSelectChipField
            {...rest}
            list={orderedRolList}
            labelGetter={(e) => e.isim}
            valueGetter={(e) => e.id}
        />
    )
}

export default VatanRolMultiSelectField;